export default "__VITE_ASSET__DspQf3tX__"